import { createSharedComposable } from "@vueuse/core";
import { userGlobalState } from "../store"
import { reactive } from "vue";
import { ActionType } from "./interface";
// 获取store的数据
const globalState = userGlobalState()
interface InjectionAuth {
    [key: string]: boolean
}
export const useInjectionAuth = createSharedComposable(() => {
    // state
    let InjectionAuth = reactive({}) as InjectionAuth;
    // actions
    async function getPageUserAction(onSuccess?: (data: InjectionAuth) => void): Promise<InjectionAuth> {
        let param = {
            account: globalState.state.userInfo.personCode,
            code: globalState.state.resourceCode
        };
        try {
            const data = await globalState.getUserAction(param);
            for (let i = 0; i < data.responseData.length; i++) {
                let item: ActionType = data.responseData[i];
                InjectionAuth[item.privilegeCode + "Auth"] = true;
            }
            if (onSuccess) {
                onSuccess(InjectionAuth); // 调用成功的回调
            }
            return InjectionAuth;
        } catch (error) {
            // 处理错误情况
            console.error("Failed to get user action", error);
            throw error;
        }
    }

    return { InjectionAuth, getPageUserAction };
});

